import { createAction } from '@reduxjs/toolkit'
import { MyNFTType } from 'hooks/setGetListMyNft'
import { ICurrentProfit, NFTItemType } from './type'

export const setMyNft = createAction<MyNFTType[]>('nft/myNft')
export const setListNFT = createAction<NFTItemType[]>('nft/listNft')
export const setCurrentProfit = createAction<ICurrentProfit>('nft/currentProfit')
